module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Caren Obligar Blog","short_name":"Caren Blog","start_url":"/","background_color":"#777d71","theme_color":"#777d71","display":"minimal-ui","include_favicon":false,"icon":"src/images/icons/dummy_icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","cacheDigest":"c43989d31bd88347e635d92a0433d7cc"},
    },{
      plugin: require('../node_modules/gatsby-plugin-netlify-cms/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
